<template>
	<div class="serverlist">
		<div class="top">Servers</div>

		<div class="item" v-for="(server, index) of servers" :key="index">
			<div class="name">{{ server.name }} <small>{{ server.title }}</small></div>
			<Progress :max="server.max_players" :value="server.players" />
			<a :href="'steam://connect/' + server.ip"><i class="fa fa-play-circle"></i> {{ server.ip }}</a>
		</div>
	</div>
</template>

<script>
import axios from "axios";
import Progress from "./Progress.vue";

export default {
	name: "Serverlist",
	components: { Progress },
	data: () => ({
		servers: [],
	}),

	methods: {
		updateServers() {
			axios.get("/servers.json").then(({ data }) => {
				this.servers = data;
				console.log("Serverlist updated");
			});
		},
	},

	mounted() {
		this.updateServers();
		setInterval(() => this.updateServers(), 60000);
	}
};
</script>


<style lang="scss">
.serverlist {
	display: flex;
	flex-direction: column;
	justify-content: center;
	overflow: hidden;
	position: absolute;
	right: calc(100% + 20px);
	width: 240px;
	top: 0px;
	height: 100%;

	.top {
		position: absolute;
		top: 0px;
		left: 0px;
		right: 0px;
		background-color: rgba(0, 0, 0, 0.25);
		text-align: center;
		padding: 10px;
		border-radius: 25px;
		color: white;
		font-weight: 500;
		font-size: 28px;
	}

	.item {
		margin-bottom: 20px;

		.name {
			font-size: 20px;
			margin-bottom: 5px;
			text-align: center;

			small {
				font-size: 14px;
				font-weight: 500;
				opacity: 0.6;
			}
		}

		a {
			display: block;
			font-size: 12px;
			opacity: 0.6;
			text-align: center;
			margin-top: 5px;
			transition: 0.25s;
			font-weight: 600;

			&:hover {
				opacity: 1;
			}

			i {
				margin-right: 3px;
			}
		}
	}
}
</style>